import React, { useState, useEffect } from "react";
import loadingSpin from "../images/loadingSpin.gif";
import AccordionLayout from "./Accordion";
import axios from "axios";
import SunEditor from 'suneditor-react';
import 'suneditor/dist/css/suneditor.min.css';
import Card from './common/Card';
import EmptyContent from "../components/common/EmptyContent";
import { textAlign } from "@mui/system";


const HealthMessage = () => {
  const [result, setResult] = useState([])
  const [loading, setLoading] = useState(false);
  const [fetchedNotes, setFetchedNotes] = useState([]);
  const [fetchError, setFetchError] = useState(false);

  const studentInfo = JSON.parse(localStorage.getItem('studentInfo'));
  const admissionnumber = studentInfo[0].admissionnumber;
  const schoolUrl = localStorage.getItem('schoolDomain');
  const idx = JSON.parse(localStorage.getItem('subSchoolData')).idx;

  useEffect(() => {
    getQuery()
  }, [])

  const getQuery = async () => {
    let Params = {
      "SchoolUrl": schoolUrl,
      "schDeploymentid": idx,
      "admissionnumber": admissionnumber,
    };
    // let Params = {
    //   "SchoolUrl": "demo.edves.net",
    //   "schDeploymentid": "1",
    //   "admissionnumber": "A027",
    // };
    setLoading(true)
    try {
      //   const response = await axios.get('https://devapi.edves.net/testapi/public/v1/getHealtDeatails/demo.edves.net/1/A027');

      const response = await axios.post("https://devapi.edves.net/testapi/public/v1/getHealtDeatails", Params);

      const newData = response.data.data.Message
      if (newData !== "No record found") {
        setResult(newData)
      }

      response.data.data.Message.length > 0 && setFetchedNotes(response.data.data.Message);
      setLoading(false)
    } catch (error) {
      console.log(error)
      setLoading(false)
      setFetchError(true);
    }
  }

  const [activeIndex, setActiveIndex] = useState(0);
  return (
    <>
      {
        loading ?
          <div className='flex justify-center w-full h-full my-24'>
            <img src={loadingSpin} alt='loading...' />
          </div>
          :
          <Card>
            {
              fetchedNotes && fetchedNotes.length === 0 && !loading && !fetchError ?
                <div className='flex justify-center w-full sm:mt-16'>
                  <EmptyContent message='No Health History Found' moreMessage='You can always check your child Health History here' />
                </div> :
                <>
                  {result.length < 1 ?
                    <div className='flex justify-center w-full sm:mt-16'>
                      <EmptyContent message='No Health History Found' moreMessage='You can always check your child Health History here' />
                    </div>
                    :
                    result?.map((item, index) => {
                      return (
                        <AccordionLayout
                          title={item?.symptom}
                          index={index + 1}
                          activeIndex={activeIndex}
                          setActiveIndex={setActiveIndex}
                        >
                          <span>Case Note </span> <SunEditor hideToolbar={true} disable={true} height="100%" setContents={item?.casenote} />

                          <br></br>
                          <br></br>
                          <div style={{ display: "flex", justifyContent: 'space-between', alignItems: 'center', flexWrap: "wrap" }}>
                            <div style={{minWidth: 120, whiteSpace:'nowrap', textOverflow:"ellipsis", overflow:"hidden" }}>
                              <span>Personnel: </span> {item?.personincharge}
                            </div>

                            <div style={{minWidth: 120, whiteSpace:'nowrap', textOverflow:"ellipsis", overflow:"hidden", textAlign: 'right' }}>
                              <span>Date: </span> {item?.timestp}
                            </div>

                          </div>

                        </AccordionLayout>
                      )
                    })
                  }
                </>


            }

          </Card>
      }
    </>
  );
};

export default HealthMessage;
